import React, { lazy, Suspense, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import * as urls from "../utils/URLConst";
import makeRequest from "../utils/makeRequest";
import { useDispatch, useSelector } from "react-redux";
import { handleLoader } from "../redux/reducers/layout";
import toastNotify from "../utils/ToastNotify";
import { Card, Col, Row } from "react-bootstrap";
import Loader from "../componants/loader/Loader";
import { BiCategory, BiChevronRight, BiFile, BiHomeAlt, BiLabel } from "react-icons/bi";
import SelectField from "../componants/textField/SelectField";

const Documents = lazy(() => import('./dashboard/Documents'));

const Help = () => {
  const dispatch = useDispatch();
  const [clientHelpDocuments, setClientHelpDocuments] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const screenWidth = useSelector((state) => state.layout.currentScreenWidth);
  const [selectedId, setSelectedId] = useState("");

  async function fetchClientHelpDocuments() {
    try {
      dispatch(handleLoader(true));
      const result = await makeRequest(
        "POST",
        urls.getClientHelpDocuments,
        { category: selectedCategory },
        {}
      );
      if (result.STATUS === "0") {
        const response = result.RESPONSE;
        setClientHelpDocuments(response);
        setSelectedId(response[0].CAT_NM);
        setSelectedCategory(response[0]);
      } else {
        toastNotify(result.Message, "error");
      }
    } catch (error) {
      // Ignore Case
    } finally {
      dispatch(handleLoader(false));
    }
  }

  useEffect(() => {
    fetchClientHelpDocuments();
  }, []);

  return (
    <>
      <div className="container-xxl flex-grow-1 container-p-y">
        <div className="row date-time container-top">
          <div className="col-lg-12 col-md-12 col-12">
            <div className="pb-2 mt-2">
              <span className="d-none d-md-inline"><BiHomeAlt />&nbsp;</span>
              <NavLink to="/dashboard" className="text-secondary d-none d-md-inline">
                Dashboard /
              </NavLink>
              <span className="navigation-header-text ps-1">  Help </span>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-6"></div>
        </div>

        <Row>
          <Col lg={4}>
            {screenWidth >= 933 &&
              <div className="pb-2">
                <BiCategory className="me-2" />
                <span className="fw-bold">Category</span>
              </div>
            }

            <Card className={screenWidth >= 933 ? "overflow-hidden" : ""}>
              <Card.Body className="p-0">
                {screenWidth >= 933 ?
                  <ul className="p-0 mb-0">
                    {clientHelpDocuments &&
                      clientHelpDocuments.map((category, index) => (
                        <li
                          key={index}
                          className={`help-menu ${selectedCategory.CAT_NM === category.CAT_NM ? "active" : ""}`}
                          onClick={() => setSelectedCategory(category)}
                        >
                          <div className=" w-100">
                            <BiLabel />
                            <span className="manu-list-doc px-2 text-base">
                              {category.CAT_NM}
                              <span>
                                <BiChevronRight className="arrow-icon pt-1" style={{ fontSize: 25 }} />
                              </span>
                            </span>
                          </div>
                        </li>
                      ))}
                  </ul>
                  :
                  <div className='m-3'>
                    <SelectField
                      placeholder="Menu"
                      options={clientHelpDocuments.map((items) => {
                        return { value: items.CAT_NM, label: items.CAT_NM, data: items }
                      })}
                      value={{ value: selectedId, label: selectedId }}
                      onChange={(e) => { setSelectedId(e?.value); setSelectedCategory(e?.data) }}
                    />
                  </div>
                }
              </Card.Body>
            </Card>
          </Col>

          <Col lg={8} className="mt-md-0 mt-3">
            <div className="pb-2">
              <BiFile className="me-2" />
              <span className="fw-bold">Document</span>
            </div>
            <Card>
              <Card.Body
                className="p-0"
              >
                <Suspense fallback={<Loader isLoader={true} />}>
                  {selectedCategory?.DTL &&
                    <Documents data={selectedCategory?.DTL} flag="H" />
                  }
                </Suspense>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div >
    </>
  );
};
export default Help;
